import * as React from "react"
import { Grid } from "@mui/material"

import {flashOffersError, flashOffersReportDrawerIsOpen} from "../@signals";
import {TABS_OFFERS} from "../@constants"
import CustomDashboardsPrimorFlashOffersErrorPage from "../errorPage";
import {useCustomDashboardsPrimorFlashOffersOffers} from "../@hooks";
import CustomDashboardsPrimorFlashOffersOffersTabTable from "./TabTable"
import CustomDashboardsPrimorFlashOffersOffersTabs from "./Tabs"


export default function CustomDashboardsPrimorFlashOffers() {
    const { isLoading, dataDruni, dataPrimor, handleChangeReloadData, handleExcel } = useCustomDashboardsPrimorFlashOffersOffers()

    return <Grid container spacing={2}>
        <Grid item xs={12} data-tour="flash-offers-tabs">
            <CustomDashboardsPrimorFlashOffersOffersTabs />
        </Grid>

        <CustomDashboardsPrimorFlashOffersOffersTabTable
            tabID={TABS_OFFERS.DRUNI}
            isLoading={isLoading}
            data={dataDruni}
            handleChangeReloadData={handleChangeReloadData}
            handleExcel={handleExcel}
        />

        <CustomDashboardsPrimorFlashOffersOffersTabTable
            tabID={TABS_OFFERS.PRIMOR}
            isLoading={isLoading}
            data={dataPrimor}
            handleExcel={handleExcel}
        />

        <Grid item xs={12}>
            {!!flashOffersError.value && <CustomDashboardsPrimorFlashOffersErrorPage errorCode={flashOffersError.value} /> }
        </Grid>


    </Grid>
}